import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import ShopPage from './shop-components/shop-page';
import FooterV2 from './global-components/footer-v2';

const Shop = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Shop" />
        <ShopPage />
        <FooterV2 />
    </div>
}

export default Shop

